import { Directive, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';

import { Validator } from '../core/model/validator';
import { ValidatorBase } from '../core/model/validator-base';

@Directive({
    selector: "[cpr-validator]",
    host: { '(change)': 'changed($event)' },
    exportAs: 'validator'
})
export class CprValidatorDirective extends ValidatorBase implements OnInit, Validator
{
    @Input('cpr-validator') public getValue: () => string;
    @Input('view') cprPart: 'dob' | 'check' = 'dob';

    @Output('validated') validated = new EventEmitter();

    public valid: boolean;

    public constructor(viewRef: ViewContainerRef)
    {
        super(viewRef);
        this.elementRef = viewRef.element.nativeElement;
    }

    public changed(event: any): void
    {
        this.validate();
    }

    public validate(): boolean
    {
        this.valid = this.isValid();
        this.validated.emit();
        return this.valid;
    }

    protected isValid(): boolean
    {
        const value = this.removeIllegalCharacters(this.elementRef.value).value;

        let valid = false;

        switch (this.cprPart)
        {
            case 'check':
                valid = /^[0-9]{3,4}$/.test(value);
                break;
            default:
                valid = /^[0-9]{6}$/.test(value);
                break;
        }

        if (valid && value !== this.elementRef.value)
        {
            this.elementRef.value = value;
        }

        return valid;
    }

    public ngOnInit(): void { }
}
